import React, { Component } from 'react';
export default class HeaderLocationName extends Component {
  render() {
    let siteCategoryGroupId = window.sessionStorage.getItem('siteCategoryId')
    let storeName = window.sessionStorage.getItem('storeName')
    let citySessionName = localStorage.getItem('cityText');
    let locationSessionName = localStorage.getItem('locationText');
    let storeId = window.sessionStorage.getItem('storeId')
    return (
      (() => {
        if (siteCategoryGroupId !== '0' && siteCategoryGroupId !== 'null' && siteCategoryGroupId !== null) {
          return (
            <div className="locationTextDiv">{(storeName !== null && storeName !== '' ? <b>{storeName}</b> : '')} {locationSessionName}</div>
          );
        }
        else if (storeId !== null && storeId !== 'null' && storeId !== '') {
          return (
            <div className="locationTextDiv">{locationSessionName}, {citySessionName !== null ? citySessionName.split(' ')[0] : ''}</div>
          );
        }
      })()
    );
  }
}